export { default } from './alert-dialog';
export * from './alert-dialog.interfaces';
